module.exports = __webpack_public_path__ + "img/TamponFR.074ea459.png";